import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ElAsyncAutocompleteModule } from '@el-async-autocomplete';
import { ElDataListTableModule } from '@el-data-list-table';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'angular-calendar';

import { MaterialModule } from '../../material.module';
import { SharedModule } from '../shared/shared.module';

import { AttendanceConfigurationComponent } from './attendance-configuration/attendance-configuration.component';
import { AttendanceComponent } from './attendance.component';
import { AttendanceRoutingModule } from './attendance-routing.module';

@NgModule({
  declarations: [AttendanceComponent, AttendanceConfigurationComponent],
  imports: [
    MaterialModule,
    MatIconModule,
    MatDividerModule,
    MatCardModule,
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    ElDataListTableModule,
    MaterialModule,
    AttendanceRoutingModule,
    MatChipsModule,
    CalendarModule,
    MtxDatetimepickerModule,
    ElAsyncAutocompleteModule,
    CKEditorModule,
    MatStepperModule,
    MatButtonModule,
  ],
})
export class AttendanceModule {}
